// Announcement Bar - Perfect Seamless Scrolling with Spacing

(function() {
  'use strict';
  
  function initScrollingAnnouncement() {
    const message = document.querySelector('.announcement-bar__message, .announcement-bar p');
    
    if (!message) {
      console.log('Announcement message not found');
      return;
    }
    
    // Get original text with bullets
    const originalText = message.textContent.trim();
    
    // Add wide spacing between sections
    const spacer = '                                        •                                        ';
    
    // Create the full scrolling text (repeat 3 times for seamless loop)
    const fullText = originalText + spacer + originalText + spacer + originalText + spacer;
    
    // Replace the content
    message.textContent = fullText;
    
    // Store for reference
    message.setAttribute('data-full-text', fullText);
    
    console.log('Scrolling announcement initialized with spacing');
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollingAnnouncement);
  } else {
    initScrollingAnnouncement();
  }
  
  // Try again after delay
  setTimeout(initScrollingAnnouncement, 500);
})();